import { apiAxiosAuth } from 'services/api';

export async function deleteUserReq(userId: string, handleNotify: any) {
	let isSuccess = false;

	await apiAxiosAuth
		.delete(`users/${userId}`)
		.then(() => {
			isSuccess = true;

			handleNotify('Usuário deletado com sucesso', 'success');
		})
		.catch((error) => {
			isSuccess = false;

			handleNotify(
				error?.message || 'Ocorreu algum erro para deletar o usuário',
				'error'
			);
		});

	return isSuccess;
}
